'use strict';

export default {
  adminProperties: {
    settings: {
      options: {
        options: 'Options',
        default: 'Default',
        order: 'Order',
        hide: 'Hide',
      },
    },
    fields: {
      common: {
        text: 'Title',
        textColor: 'Title Color',
        hiddenText: 'Hidden Text',
        required: 'Required',
        visible: 'Visible',
        enabled: 'Enabled',
        excludeFromReport: 'Exclude From Report',
        placeholder: 'Placeholder',
      },
      acknowledgment: {
        defaultValue: 'Default Value',
      },
      birthdate: {
        defaultValue: 'Default Date',
      },
      checkbox: {
        defaultValue: 'Default Value',
      },
      date: {
        defaultValue: 'Default Date',
      },
      datetime: {
        defaultValue: 'Default Date/Time',
      },
      documentViewer: {
        defaultValue: 'Link',
        documentName: 'Document Name',
        documentType: 'Document Type',
      },
      email: {
        defaultValue: 'Default Email',
        sendReceipt: 'Send Receipt to this email',
      },
      embeddedPhoto: {
        defaultValue: 'Image Link',
        alt: 'Alt Text',
      },
      longText: {
        min: 'Min. Length',
        max: 'Max. Length',
        defaultValue: 'Default Value',
      },
      numeric: {
        min: 'Min',
        max: 'Max',
        decimals: 'Decimals',
        defaultValue: 'Default Value',
      },
      optionList: {
        multiSelection: 'Allow multiple selections',
      },
      rating: {
        starsColor: 'Stars Color',
        starCount: 'Star Count',
        allowHalfStar: 'Allow Half Star',
        defaultValue: 'Default Rating',
      },
      staticText: {
        defaultValue: 'Static Text',
      },
      text: {
        min: 'Min. Length',
        max: 'Max. Length',
        defaultValue: 'Default Value',
      },
      time: {
        defaultValue: 'Default Time',
      },
      toggle: {
        defaultValue: 'Default Value',
      },
      video: {
        videoPlayer: 'Video Player',
        videoLink: 'Video Link',
      },
      weblink: {
        defaultValue: 'Link',
      },
      yesNo: {
        allowNa: 'Allow N/A',
        defaultValue: 'Default Value',
      },
      paymentZone: {
        providers: 'Providers',
        options: 'Options',
        choices: 'Choices',
      },
    },
  },
};
